import {inject, Injectable} from '@angular/core';
import * as echarts from 'echarts/core';
import {BarChart, LineChart} from 'echarts/charts';
import {GridComponent} from 'echarts/components';
import {CanvasRenderer} from 'echarts/renderers';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import {JsonApiResponse} from '../../shared/models/JsonApiResponse';
import {environment} from '../../../environments/environment';
import {catchError} from 'rxjs/operators';
import {HttpErrorHandler} from '../../http.error.handler';

echarts.use([LineChart, BarChart, GridComponent, CanvasRenderer]);


@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private readonly http = inject(HttpClient);

  getAnalyticsReport(metrics: string, startDate: string, endDate: string) {
    const params = {metrics, startDate, endDate};
    return firstValueFrom(
      this.http.get<JsonApiResponse<AnalyticsReportResponse>>(
        `${environment.services.service}v1/report-analytics/public-portal-report`, {params}
      ).pipe(catchError(HttpErrorHandler.handleError))
    );
  }

}


export class AnalyticsReportResponse {
  resolution: Resolution;
  stats: AnalyticsReportRow[] = [];
}

export class AnalyticsReportRow {
  time: string;
  [key: string]: string | number;
}

export enum Resolution {
  HOUR = 'HOUR',
  DAY = 'DAY',
  MONTH = 'MONTH',
  YEAR = 'YEAR'
}